import { DocumentTitle } from '@monorepo/shared/componentsV2/DocumentTitle';
import { useLinkOnSameProject } from '@monorepo/shared/hooks/navigation/useLinkOnSame/useLinkOnSameProject';
import React, { useCallback } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { LogEntriesExistingAiSubmissionsModal } from './LogEntriesReviewModal/LogEntriesExistingAiSubmissionsModal';

type AiSubmissionLocationState = {
  logEntryId?: string;
  returnPageNumber?: number;
  returnPath?: string;
  isReadOnly?: boolean;
};

export function AiSubmissionPage() {
  const { organizationId, projectId, logId, edpAiSubmissionId } = useParams();
  if (!organizationId || !projectId || !logId || !edpAiSubmissionId) {
    throw new Error(
      "AiSubmissionPage was rendered with a url that doesn't have organizationId, projectId, logId or edpAiSubmissionId",
    );
  }
  const { state }: { state: AiSubmissionLocationState | null } = useLocation();
  const logEntryId = state?.logEntryId;
  const returnPageNumber = state?.returnPageNumber ?? 0;

  const recordsLink = useLinkOnSameProject(
    `/logs/${logId}/records/pages/${returnPageNumber}`,
  );
  const navigate = useNavigate();
  /** Where to go on close when opened from outside the Records tab. */
  const returnPath = state?.returnPath ?? recordsLink;
  const handleClose = useCallback(
    () => navigate(returnPath),
    [navigate, returnPath],
  );

  return (
    <>
      <DocumentTitle title="AI Submission" />
      <LogEntriesExistingAiSubmissionsModal
        edpAiSubmissionId={edpAiSubmissionId}
        logEntryId={logEntryId}
        logId={logId}
        onClose={handleClose}
        organizationId={organizationId}
        projectId={projectId}
        isReadOnly={state?.isReadOnly}
      />
    </>
  );
}
